import React, { useMemo } from 'react';
import {
  INGRESO_POR_DIA_TITULO_DEFAULT,
  INGRESO_POR_DIA_COLUMNS,
  applyIngresoPorDiaColumnLabels,
  formatIngresoPorDiaCell,
  getIngresoPorDiaTotals,
  mergeIngresoPorDiaEncabezado,
  normalizeIngresoPorDiaRow,
} from '../../../utils/ingresoPorDiaReportModel';
import '../PopularidadReportLayout/PopularidadReportLayout.css';
import '../DescuentosCortesiasReportLayout/DescuentosCortesiasReportLayout.css';
import ReporteFiltrosEncabezadoLista from '../ReporteFiltrosEncabezadoLista/ReporteFiltrosEncabezadoLista';
import './IngresoPorDiaReportLayout.css';

const meaningful = (v) => v != null && String(v).trim() !== '';

export default function IngresoPorDiaReportLayout({
  className = '',
  rawRows = [],
  encabezadoApi = null,
  encabezadoFallback = null,
  reporteTitulo = INGRESO_POR_DIA_TITULO_DEFAULT,
  apiTotales = null,
  columnasLabels = null,
  vistaIngreso = 'dia',
}) {
  const enc = useMemo(
    () => mergeIngresoPorDiaEncabezado(encabezadoApi, encabezadoFallback),
    [encabezadoApi, encabezadoFallback]
  );

  const cols = useMemo(
    () => applyIngresoPorDiaColumnLabels(columnasLabels, INGRESO_POR_DIA_COLUMNS),
    [columnasLabels]
  );

  const normRows = useMemo(
    () => (Array.isArray(rawRows) ? rawRows.map(normalizeIngresoPorDiaRow) : []),
    [rawRows]
  );

  const totals = useMemo(
    () => getIngresoPorDiaTotals(normRows, apiTotales),
    [normRows, apiTotales]
  );

  const titulo = String(enc.reporteTitulo || reporteTitulo).toUpperCase();

  let nombreDisplay = enc.nombreComercial || '';
  if (enc.sucursalAppend && !nombreDisplay.toUpperCase().includes(enc.sucursalAppend.toUpperCase())) {
    nombreDisplay = nombreDisplay
      ? `${nombreDisplay} - ${enc.sucursalAppend.toUpperCase()}`
      : enc.sucursalAppend.toUpperCase();
  }

  return (
    <div className={`dc-report ipd-report pop-report ${className}`.trim()}>
      <header className="pop-report-headerenc">
        {meaningful(nombreDisplay) && (
          <div className="pop-report-headerenc__empresa">
            <h1 className="pop-report-headerenc__nombre">{nombreDisplay.toUpperCase()}</h1>
            {meaningful(enc.domicilioFiscal) && (
              <p className="pop-report-headerenc__detalle ipd-report-domicilio">{enc.domicilioFiscal}</p>
            )}
            {meaningful(enc.rfc) && (
              <p className="pop-report-headerenc__detalle pop-report-headerenc__rfc">RFC: {enc.rfc.toUpperCase()}</p>
            )}
          </div>
        )}
        <div className="pop-report-headerenc__titulos">
          <h2 className="pop-report-headerenc__reporte dc-report-title-highlight ipd-report-title">{titulo}</h2>
        </div>
        <div className="pop-report-headerenc__filtros">
          {meaningful(enc.periodoTexto) && <p className="pop-report-headerenc__filtros-line">{enc.periodoTexto}</p>}
          <ReporteFiltrosEncabezadoLista
            className="reporte-filtros-meta--report"
            label="Sucursales"
            texto={enc.sucursalesTexto}
            items={enc.sucursalesItems}
            uppercase
          />
          <ReporteFiltrosEncabezadoLista
            className="reporte-filtros-meta--report"
            label="Cajas"
            texto={enc.cajasTexto}
            items={enc.cajasItems}
            uppercase
          />
          {meaningful(enc.turnosTexto)  && <p className="pop-report-headerenc__filtros-line">Turnos: {enc.turnosTexto}</p>}
        </div>
      </header>

      <div className="dc-report-table-wrap ipd-table-scroll">
        <table className="dc-report-table ipd-report-table ipd-report-table--wide">
          <thead>
            <tr>
              {cols.map((c) => (
                <th key={c.id} className={c.align === 'right' ? 'dc-num' : 'dc-text'}>{c.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {normRows.length === 0 ? (
              <tr>
                <td className="dc-report-empty-row" colSpan={cols.length}>Sin movimientos en el rango seleccionado.</td>
              </tr>
            ) : vistaIngreso === 'total' ? null : (
              normRows.map((row, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'ipd-row-even' : 'ipd-row-odd'}>
                  {cols.map((c) => (
                    <td key={c.id} className={c.align === 'right' ? 'dc-num' : 'dc-text'}>
                      {formatIngresoPorDiaCell(c, row[c.id])}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>

          {normRows.length > 0 && (
            <tfoot>
              <tr className="dc-report-totals ipd-report-totals">
                {cols.map((c, i) => (
                  <td key={c.id} className={c.align === 'right' ? 'dc-num dc-report-totals-num' : 'dc-text dc-report-totals-spacer'}>
                    {i === 0
                      ? 'TOTAL'
                      : c.total
                      ? formatIngresoPorDiaCell(c, totals[c.id])
                      : ''}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
